/*eslint-disable */
import {
  mapGetters
} from 'vuex';
const $ = window.jQuery = require('jquery');
import axios from 'axios';
import toast from '../../../services/toast';
import countries from '../../../services/country.json'
import {
  bus
} from '../../../main';
export default {
  name: 'chat-request-user-list',
  components: {},
  props: [],
  data () {
    return {
      chatRequestList:{},
      checkDataTaskModal:false,
      chatRequestId:'',
      chatRequestConfirmId:'',
      chatRequestUserList:'',
      blockedUserId:'',
      confirmUserId:'',
      roomChatId:'',
      dataRemoveLoader:false,
      countryList:[],
    }
  },
  computed: {
  ...mapGetters([
    'chatConnectionRequestListGetters'
  ]),
  getOrgListDetailsFun(){
    return this.chatRequestList = this.$store.getters.chatConnectionRequestListGetters.data
  },
  },
  mounted () {
    bus.$emit('userFriendRequestClear', {});
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.getOrgListDetailsFun
  },
  methods: {
    getNormalUserListAgain(){
      this.$store.dispatch('chatConnectionRequestListFun').then((res) =>{
        this.chatRequestUserList = res.data.data
      }).catch((err) => {

      })
    },
    approveChatRequestFun(ApporvedUserId, blockedUserId, confirmUserId){
      this.chatRequestId = ApporvedUserId
      this.blockedUserId = blockedUserId
      this.confirmUserId = confirmUserId
      this.checkDataTaskModal = true
    },
    ApporveChatRequestConfirmFun(){
      let data = {
        id : this.chatRequestId
      }
      this.$store.dispatch('apporvedConnectionRequestFun', data).then((res) =>{
        toast.success(res.data.msg);
        let data = {
          users : [this.blockedUserId, this.confirmUserId],
          is_support_chat : false
          }
          this.$store.dispatch('chatRoomCreatedFun', data).then((res)=>{
          var chatId = res.data.data.id
          this.roomChatId = chatId.replace(/-/g, "")
          var chatSocket = new WebSocket(
              'wss://' + process.env.VUE_APP_WEBSOCKET_BASE_URL +
              '/ws/chat/' + this.roomChatId + '/'
          );
        })
        this.chatRequestId = ''
        this.checkDataTaskModal = false
        this.getNormalUserListAgain()
      }).catch((error) => {
        toast.error(error.data.data.non_field_errors || error.data.msg)

      })
    },
    unApproveChatRequestFun(id){
      this.dataRemoveLoader = true
      let data = {
        id : id,
        is_approved:false
      }
      this.$store.dispatch('apporvedConnectionRequestFun', data).then((res) =>{
        toast.success(res.data.msg);
        this.getNormalUserListAgain()
        this.dataRemoveLoader = false
      }).catch((err)=>{
        this.dataRemoveLoader = false
        toast.error(err.data.data.non_field_errors || err.data.msg);
      })

    },
    confirmBlockedUser(){
      let data = {
        blocked_user : this.blockedUserId
      }
      this.$store.dispatch('createBlockUserFun', data )
      .then((res) => {
        toast.success(res.data.msg);
        this.blockedUserId = ''
        this.checkDataTaskModal = false
        this.getNormalUserListAgain()
      }).catch((err) => {
        toast.error(err.data.data.non_field_errors || err.data.msg);
      })
    },
    closedApproveChatRequestFun(){
      this.chatRequestId = ''
      this.blockedUserId = ''
      this.checkDataTaskModal = false
      this.chatRequestUserList  = ''
    },
    getCountryFlag: function(countryCode, type) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        if (type == 'flag') {
          country = `https://www.countryflags.io/${country.value}/shiny/64.png`
        } else {
          country = country.name
        }
      } else {
        country = ''
      }
      return country;
    },
  },
  watch:{
    getOrgListDetailsFun(){
      return this.chatRequestList = this.$store.getters.chatConnectionRequestListGetters.data
    },
  }
}
